import {
  GENERATE_QUESTIONS_REQUEST,
  GENERATE_QUESTIONS_SUCCESS,
  GENERATE_QUESTIONS_FAILURE,
  FETCH_GENERATED_QUESTIONS_REQUEST,
  FETCH_GENERATED_QUESTIONS_SUCCESS,
  FETCH_GENERATED_QUESTIONS_FAILURE,
  APPROVE_GENERATED_QUESTION,
  REJECT_GENERATED_QUESTION,
  EDIT_GENERATED_QUESTION,
  UPDATE_GENERATED_PASSAGE,
  CLEAR_GENERATED_QUESTIONS
} from './AIGenerationTypes';

const initialState = {
  generatedQuestions: [],
  generatedPassage: null,
  loading: false,
  error: null,
  generationInProgress: false
};

const aiGenerationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_QUESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        generationInProgress: true,
        error: null
      };

    case GENERATE_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        generationInProgress: false,
        generatedQuestions: [...state.generatedQuestions, ...action.payload.questions],
        generatedPassage: action.payload.passage || state.generatedPassage,
        error: null
      };

    case GENERATE_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        generationInProgress: false,
        error: action.payload
      };

    case FETCH_GENERATED_QUESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_GENERATED_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        generatedQuestions: action.payload,
        error: null
      };

    case FETCH_GENERATED_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case APPROVE_GENERATED_QUESTION:
      return {
        ...state,
        generatedQuestions: state.generatedQuestions.filter(
          q => q.tempId !== action.payload
        )
      };

    case REJECT_GENERATED_QUESTION:
      return {
        ...state,
        generatedQuestions: state.generatedQuestions.filter(
          q => q.tempId !== action.payload
        )
      };

    case EDIT_GENERATED_QUESTION:
      return {
        ...state,
        generatedQuestions: state.generatedQuestions.map(q =>
          q.tempId === action.payload.tempId ? action.payload.question : q
        )
      };

    case UPDATE_GENERATED_PASSAGE:
      return {
        ...state,
        generatedPassage: state.generatedPassage
          ? { ...state.generatedPassage, ...action.payload }
          : action.payload
      };

    case CLEAR_GENERATED_QUESTIONS:
      return {
        ...state,
        generatedQuestions: [],
        generatedPassage: null,
        error: null
      };

    default:
      return state;
  }
};

export default aiGenerationReducer;
